var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fieldset",
    { staticClass: "mt-3 col-12 d-flex flex-column filter-field-set" },
    [
      _c(
        "div",
        { staticClass: "right-inner-addon mb-3" },
        [
          _c("icon", { attrs: { name: "search" } }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.boardSearchString,
                expression: "boardSearchString",
              },
            ],
            staticClass: "form-control",
            attrs: {
              id: "inactive-clients-search",
              type: "search",
              placeholder: _vm.$t("inactive-clients.searchForBoard"),
              autocomplete: "off",
            },
            domProps: { value: _vm.boardSearchString },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.boardSearchString = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "d-none",
              attrs: { for: "inactive-clients-search" },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("inactive-clients.searchForBoard")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.options, function (ref, index) {
        var id = ref.id
        var boardName = ref.name
        var ownerName = ref.ownerName
        return _c("div", { key: index, staticClass: "mt-0 mb-1" }, [
          _c("div", { staticClass: "pretty p-icon p-smooth" }, [
            _c("input", {
              staticClass: "form-check-input",
              attrs: { id: "filter-board-" + index, type: "checkbox" },
              domProps: { value: boardName, checked: _vm.isSelected(id) },
              on: {
                change: function ($event) {
                  return _vm.handleChange($event, index)
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "state p-primary" }, [
              _c("i", { staticClass: "icon fa fa-check" }),
              _vm._v(" "),
              _c(
                "label",
                {
                  staticClass:
                    "clickable text-gray text-capitalize font-weight-bold",
                  attrs: { for: "filter-board-" + index },
                },
                [_vm._v("\n          " + _vm._s(boardName) + "\n        ")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-gray text-capitalize ml-4 font-weight-normal",
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("boards.messages.boardOwner")) +
                  ": " +
                  _vm._s(ownerName) +
                  "\n    "
              ),
            ]
          ),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }